import PhotoSwipeService from "./photoSwipe.service";
import ThumbnailService from "./thumbnail.service";

class ImageService {
    constructor() {
        this.changeCallback = null;
        this.closeCallback = null;
    }

    /**
     * 이미지 갤러리 열기
     *
     * @param {Object} params
     * @param {Array} params.files 이미지 목록
     * @param {Object} params.file 선택한 이미지
     * @param {Function} params.getUrl 이미지 URL 생성 함수
     */
    async openGallery({ files, file, getUrl }) {
        const index = files.findIndex(item => item.name === file.name);
        const items = files.map(item => {
            const src = getUrl(item.name, false);

            return {
                src,
                name: item.name,
                thumb: src
            };
        });

        PhotoSwipeService.open(items, index);

        return {
            items,
            index
        };
    }
    change(index) {
        this.changeCallback?.(index);
    }
    close() {
        this.closeCallback?.();
    }
    closeGallery() {
        PhotoSwipeService.close();
    }
    onChange(callback) {
        this.changeCallback = callback;
    }
    onClose(callback) {
        this.closeCallback = callback;
    }
    nextImage() {
        PhotoSwipeService.next();
    }
    prevImage() {
        PhotoSwipeService.prev();
    }
    goToImage(index) {
        PhotoSwipeService.goTo(index);
    }
    getCurrentIndex() {
        return PhotoSwipeService.getCurrentIndex();
    }
}
export default new ImageService();